export { default as VerifyUploadingDLPhoto } from './VerifyUploadingDLPhoto';
